export const priority = [
  { value: "Normal" },
  { value: "Urgent" },
  { value: "Low" },
];

export const workOrderType = [
  { value: "Internal" },
  { value: "Resident" },
  { value: "Unit Turn" },
];

export const creationStyle = [{ value: "Per Property" }, { value: "Per Unit" }];

export const repeats = [
  { value: "Weekly" },
  { value: "Bi-weekly" },
  { value: "Monthly" },
  { value: "On-Move In" },
  { value: "On-Move Out" },
  { value: "Never, (Must Post Manually)" },
];

export const consolidateChecks = [
  { value: "Print 1 check for each bill" },
  { value: "10 bills per check" },
  { value: "All bills on single check (hide extra sub detail)" },
  { value: "All bills on single check" },
];
export const defaultGLAccount = [
  { value: "Commissions/Placement Fees" },
  { value: "Lease Renewal Fee" },
  { value: "Rental Tax Authority" },
  { value: "Vendor Discounts" },
  { value: "114: Bank Fees" },
  { value: "23272: Advertising" },
  { value: "23273: Association Fees" },
  { value: "23274: Auto and Travel" },
  { value: "23275: Cleaning and Maintenance" },
  { value: "23276: Commissions" },
  { value: "23277: Depreciation Expense" },
  { value: "23278: Insurance" },
  { value: "23279: Landscaping" },
  { value: "23280: Legal and Professional Fees" },
  { value: "23281: Licenses and Permits" },
];

export const vendorType = [
  { value: "General" },
  { value: "Utility" },
  { value: "Management Company" },
];

export const sendingPref = [
  { value: "No Payment Terms" },
  { value: "Due on Receipt" },
  { value: "Net 15" },
  { value: "Net 30" },
  { value: "Net 15 EOM" },
  { value: "Other Payment Terms" },
];

export const sortVacanciesList = [
  { value: "Days Vacant" },
  { value: "Internet Posting Status" },
  { value: "Name" },
  { value: "Market Rent" },
  { value: "Advertised Rent" },
  { value: "Website Posting Status" },
  { value: "Bedrooms" },
  { value: "Available Date" },
];

export const bedRooms = [...Array(20).keys()].map((i) => i + 1);

export const bathRooms = [...Array(20).keys()].map((i) => i + 0.5);

export const additionalOccupants = [...Array(10).keys()].map((i) => i + 1);

export const sources = [
  { value: "Abodo" },
  { value: "Apartment Advisor" },
  { value: "Apartment List" },
  { value: "Zillow Rental Network" },
  { value: "Apartments.com" },
  { value: "Zumper" },
];

export const accountType = [
  { value: "Checking" },
  { value: "Saving" },
  { value: "Others" },
];

export const phoneType = [
  { value: "Fax" },
  { value: "Home" },
  { value: "Mobile" },
  { value: "Office" },
];

export const applicantType = [
  { value: "Financially Responsible" },
  { value: "Co-signer" },
];

export const months = [
  { value: "January" },
  { value: "February" },
  { value: "March" },
  { value: "April" },
  { value: "May" },
  { value: "June" },
  { value: "July" },
  { value: "August" },
  { value: "September" },
  { value: "October" },
  { value: "November" },
  { value: "December" },
];

export const salutations = [
  {
    value: "Dr.",
  },
  {
    value: "Mr.",
  },
  {
    value: "Mr. & Mrs.",
  },
  {
    value: "Mrs.",
  },
  {
    value: "Ms.",
  },
];
export const vendorTradType = [
  {
    value: "Alarm/Security",
  },
  {
    value: "Appliances",
  },
  {
    value: "Capital Improvements",
  },
  {
    value: "Carpet Cleaning",
  },
  {
    value: "Carpet/FLooring",
  },
  {
    value: "Cleaning",
  },
  {
    value: "Deck Repair",
  },
];

export const states = [
  {
    value: "Alabama",
    label: "AL",
  },
  {
    value: "Alaska",
    label: "AK",
  },
  {
    value: "American Samoa",
    label: "AS",
  },
  {
    value: "Arizona",
    label: "AZ",
  },
  {
    value: "Arkansas",
    label: "AR",
  },
  {
    value: "California",
    label: "CA",
  },
  {
    value: "Colorado",
    label: "CO",
  },
  {
    value: "Connecticut",
    label: "CT",
  },
  {
    value: "Delaware",
    label: "DE",
  },
  {
    value: "District Of Columbia",
    label: "DC",
  },
  {
    value: "Federated States Of Micronesia",
    label: "FM",
  },
  {
    value: "Florida",
    label: "FL",
  },
  {
    value: "Georgia",
    label: "GA",
  },
  {
    value: "Guam",
    label: "GU",
  },
  {
    value: "Hawaii",
    label: "HI",
  },
  {
    value: "Idaho",
    label: "ID",
  },
  {
    value: "Illinois",
    label: "IL",
  },
  {
    value: "Indiana",
    label: "IN",
  },
  {
    value: "Iowa",
    label: "IA",
  },
  {
    value: "Kansas",
    label: "KS",
  },
  {
    value: "Kentucky",
    label: "KY",
  },
  {
    value: "Louisiana",
    label: "LA",
  },
  {
    value: "Maine",
    label: "ME",
  },
  {
    value: "Marshall Islands",
    label: "MH",
  },
  {
    value: "Maryland",
    label: "MD",
  },
  {
    value: "Massachusetts",
    label: "MA",
  },
  {
    value: "Michigan",
    label: "MI",
  },
  {
    value: "Minnesota",
    label: "MN",
  },
  {
    value: "Mississippi",
    label: "MS",
  },
  {
    value: "Missouri",
    label: "MO",
  },
  {
    value: "Montana",
    label: "MT",
  },
  {
    value: "Nebraska",
    label: "NE",
  },
  {
    value: "Nevada",
    label: "NV",
  },
  {
    value: "New Hampshire",
    label: "NH",
  },
  {
    value: "New Jersey",
    label: "NJ",
  },
  {
    value: "New Mexico",
    label: "NM",
  },
  {
    value: "New York",
    label: "NY",
  },
  {
    value: "North Carolina",
    label: "NC",
  },
  {
    value: "North Dakota",
    label: "ND",
  },
  {
    value: "Northern Mariana Islands",
    label: "MP",
  },
  {
    value: "Ohio",
    label: "OH",
  },
  {
    value: "Oklahoma",
    label: "OK",
  },
  {
    value: "Oregon",
    label: "OR",
  },
  {
    value: "Palau",
    label: "PW",
  },
  {
    value: "Pennsylvania",
    label: "PA",
  },
  {
    value: "Puerto Rico",
    label: "PR",
  },
  {
    value: "Rhode Island",
    label: "RI",
  },
  {
    value: "South Carolina",
    label: "SC",
  },
  {
    value: "South Dakota",
    label: "SD",
  },
  {
    value: "Tennessee",
    label: "TN",
  },
  {
    value: "Texas",
    label: "TX",
  },
  {
    value: "Utah",
    label: "UT",
  },
  {
    value: "Vermont",
    label: "VT",
  },
  {
    value: "Virgin Islands",
    label: "VI",
  },
  {
    value: "Virginia",
    label: "VA",
  },
  {
    value: "Washington",
    label: "WA",
  },
  {
    value: "West Virginia",
    label: "WV",
  },
  {
    value: "Wisconsin",
    label: "WI",
  },
  {
    value: "Wyoming",
    label: "WY",
  },
];
